import React, { useState } from 'react';
import { Form, Button, Container, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaUpload } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AnnouncementForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    department: '',
    date: '',
    documentUrl: '',
    content: ''
  });

  const departments = [
    'İmar ve Şehircilik Müdürlüğü',
    'Veteriner İşleri Müdürlüğü',
    'Park ve Bahçeler Müdürlüğü',
    'Fen İşleri Müdürlüğü'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    // Dosya yükleme işlemi burada yapılacak
    console.log('Selected file:', e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Burada API çağrısı yapılacak
    console.log('Form data:', formData);
    navigate('/announcements');
  };

  return (
    <Container>
      <Card className="mt-4 mb-4">
        <Card.Body>
          <h2 className="mb-4">Yeni İlan Ekle</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>İlan Konusu</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>İlan Birimi</Form.Label>
              <Form.Select
                name="department"
                value={formData.department}
                onChange={handleChange}
                required
              >
                <option value="">Birim Seçiniz</option>
                {departments.map((dept, index) => (
                  <option key={index} value={dept}>
                    {dept}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>İlan Tarihi</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Doküman URL</Form.Label>
              <Form.Control
                type="url"
                name="documentUrl"
                value={formData.documentUrl}
                onChange={handleChange}
                placeholder="https://"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>İlan Dosyası</Form.Label>
              <div className="d-flex align-items-center gap-3">
                <Form.Control
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx"
                />
                <Button variant="outline-secondary">
                  <FaUpload className="me-2" />
                  Yükle
                </Button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Detay</Form.Label>
              <ReactQuill
                theme="snow"
                value={formData.content}
                onChange={(value) => {
                  setFormData(prevState => ({
                    ...prevState,
                    content: value
                  }));
                }}
                modules={{
                  toolbar: [
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'font': [] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    ['link', 'image', 'video'],
                    ['clean'],
                    ['code-block']
                  ]
                }}
                style={{ height: '400px', marginBottom: '50px' }}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => navigate('/announcements')}>
                İptal
              </Button>
              <Button variant="primary" type="submit">
                Kaydet
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AnnouncementForm;
